import { render, staticRenderFns } from "./FamilyGroups.vue?vue&type=template&id=0411ac9f&scoped=true&lang=html&"
import script from "./FamilyGroups.vue?vue&type=script&lang=js&"
export * from "./FamilyGroups.vue?vue&type=script&lang=js&"
import style0 from "./FamilyGroups.vue?vue&type=style&index=0&id=0411ac9f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0411ac9f",
  null
  
)

export default component.exports